import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { withStyles, useTheme, useMediaQuery } from "@material-ui/core";
import { AppBar, Box, Toolbar, IconButton } from "@material-ui/core";

import { useCustomQuery } from "../hooks";
import { fr, inheritSize, loginContainer, fcAllCenter, inheritHeight, fcJc } from "../utilities/styles/index";
import { StyledBox } from '../components/StyledMuiElements';

import backIcon from "../assets/backArraow.svg";

const MainAppContainer = withStyles((theme) => ({
  root: {
    marginTop: "64px",
  },
}))(Box);

const WrapperContainer = withStyles((theme) => ({
  root: {},
}))(Box);

const backRedirection = (location, navigate, backPathData) => {
  const { search } = location;
  // Exit PWA
  if (location.pathname === "/" || location.pathname === "/home") {
    window.exitFromPWA();
    return;
  }

  if (backPathData.backPath) {
    navigate(`${backPathData.backPath}${search}`);
  } else navigate(-1);
};

const AppBarTop = () => {
  const { data: backPathData } = useCustomQuery({ section: "backPath" });
  const open=true

  const theme = useTheme();
  const navigate = useNavigate();
  const location = useLocation();

  if (location.pathname === "/registrationSuccessful") return null;

  return (
    <AppBar
      open={open}
      style={{
        backgroundColor: theme.palette.common.white,
        boxShadow: "none",
      }}
    >
      <Toolbar>
        <IconButton
          aria-label="open drawer"
          edge="start"
          sx={{ mr: 2, ...(open && { display: "none" }) }}
          onClick={() => backRedirection(location, navigate, backPathData)}
        >
          <img src={backIcon} />
        </IconButton>
      </Toolbar>
    </AppBar>
  );
};

const Wrapper = ({ children }) => {
  const theme = useTheme();
  const matches = useMediaQuery(theme.breakpoints.down("md"));
  return (
    // <div style={{ ...inheritSize, ...fcAllCenter }}>
    // <StyledBox style={{ ...inheritHeight, ...fcJc, ...loginContainer }}>
    <WrapperContainer
      style={{
        ...inheritSize,
        ...fr,
      }}
      matches={matches}
    >
      <AppBarTop />
      <MainAppContainer
        // open={open}
        open={true}
        matches={matches}
        style={{ height: "90%", width: "100%", ...fr }}
      >
        {children}
      </MainAppContainer>
    </WrapperContainer>
    // </StyledBox>
    // </div>
  );
};

export default Wrapper;
